import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import ErrorToast from '@/components/toasts/ErrorToast';
import { responseError } from '@/utils/errors';
import actions from '../constants';
import DatasourceUpdatedToast from '../components/DatasourceUpdatedToast';
import SaveWithDatasourceErrorToast from '../components/SaveWithDatasourceErrorToast';

export function* datasourceUpdateToast({ name }) {
  yield call(showToast, <DatasourceUpdatedToast name={name} />);
}

export function* datasourceWizardToast({ code, name, templateChanged }) {
  if (templateChanged) {
    yield call(showToast, <UpdatedToast code={code} name={name} />);
  } else {
    yield call(showToast, <DatasourceUpdatedToast name={name} />);
  }
}

export function* datasourceWizardErrorToast(action) {
  if (action.templateChanged) {
    yield call(showToast, <SaveWithDatasourceErrorToast title={action.name} error={action.error} />);
  } else {
    yield call(showToast, <ErrorToast
      operation="actions.update"
      name={action.name}
      error={responseError(action).message}
    />);
  }
}

export function* clearDataSourceErrorToast({ error, title }) {
  if (error) {
    yield call(showToast, <SaveWithDatasourceErrorToast title={title} error={error} />);
  }
}

export default function* datasourceToasts() {
  yield takeEvery(actions.SAVE_DATASOURCE_SETTINGS_SUCCESS, datasourceUpdateToast);
  yield takeEvery(actions.SAVE_DATASOURCE_WIZARD_SUCCESS, datasourceWizardToast);
  yield takeEvery(actions.SAVE_DATASOURCE_WIZARD_ERROR, datasourceWizardErrorToast);
  yield takeEvery(actions.REMOVE_DATASOURCE_SETTINGS, clearDataSourceErrorToast);
}
